import React from 'react';
import Navbar from 'components/Navigation';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './StaticHeader.scss';// to import local scss fle

const StaticHeader = props => (
  <div className={props.page === 'sports' ? cn('col s12', styles.sportsHeader) : cn('col s12', styles.aboutUsHeader)}>
    <Navbar {...props} />
    <div className={styles.bottomText}>
      <span>
        {props.page === 'sports' ? 'We Provide Unmatched Social Media Exposure!' : '' }
        {props.page === 'about_us' ? 'College Football Recruiting Never Stops!' : '' }
        {props.page === 't&c' ? 'TERMS OF SERVICE AND USER AGREEMENT' : ''}
      </span>
    </div>
  </div>
);

StaticHeader.propTypes = {
  page: PropTypes.string.isRequired,
};

export default StaticHeader;



// WEBPACK FOOTER //
// ./src/components/StaticPageHeader/StaticHeader.js